import React from 'react';
import { Link } from 'react-router-dom';
import './HomeSeoContent.css';

const HomeSeoContent = () => {
    return (
        <section className="home-seo-content" aria-labelledby="home-seo-title">
            <div className="home-seo-container">
                <h2 id="home-seo-title" className="home-seo-main-title">Welcome to TimbrLux Stays</h2>
                <p>
                    TimbrLux Stays offers beautifully designed <strong>vacation homes in Maine</strong>, hosted with
                    genuine warmth and cared for with intention. From cozy mountain cabins to spacious chalets, our
                    collection of <strong>vacation home rentals in Maine</strong> is built around comfort, quality,
                    and a stay that feels effortless from the moment you arrive.
                </p>

                <h3>Why Choose Our Vacation Homes in Maine</h3>
                <p>
                    What sets TimbrLux Stays apart from typical listings is the level of care behind every stay.
                    Each of our <strong>luxury places to stay in Maine</strong> is thoughtfully designed, professionally
                    cleaned, and personally hosted, so you can relax knowing every detail has been considered. Booking
                    direct with us also means better rates, faster communication, and a host who's genuinely invested
                    in your experience.
                </p>

                <h3>Explore Our Luxury Places to Stay in Maine</h3>
                <p>
                    Our current flagship property, Frost Pine Chalet, is a five-bedroom mountain retreat near Sunday
                    River, complete with a hot tub, sauna, and game room. We're expanding our collection of
                    <strong> vacation homes for rent in Maine</strong> to include more locations across the state, so
                    guests can find the right setting for every trip, from lakefront escapes to mountain hideaways.
                </p>

                <h3>Popular Maine Destinations We Cover</h3>
                <p>
                    TimbrLux Stays is rooted in western Maine's Sunday River region, with Frost Pine Chalet located in
                    Newry, just minutes from the resort and Screw Auger Falls. We're also expanding into Bethel, Maine,
                    bringing more <strong>vacation rental Maine</strong> options and <strong>holiday homes in Maine
                    USA</strong> to guests exploring the White Mountains area.
                </p>

                <h3>Find Vacation Homes for Rent in Maine for Every Occasion</h3>
                <p>
                    Whether you're planning a family getaway, a ski trip, a romantic retreat, or a reunion with
                    friends, our <strong>vacation homes for rent in Maine</strong> are designed to fit the occasion.
                    Spacious living areas, multiple bedrooms, and thoughtful amenities make our <strong>vacation home
                    in Maine</strong> listings a comfortable fit for groups of nearly any size.
                </p>

                <h3>What Guests Can Expect</h3>
                <p>
                    Every stay with TimbrLux Stays includes fresh linens, a fully equipped kitchen, high-speed Wi-Fi,
                    and hosting that feels personal rather than transactional. Amenities like a private hot tub, sauna,
                    and game room reinforce what makes our <strong>luxury stays in Maine</strong> memorable, comfortable,
                    and easy to book direct through{' '}
                    <Link to="/property/frost-pine-chalet">Frost Pine Chalet</Link>.
                </p>
            </div>
        </section>
    );
};

export default HomeSeoContent;
